module.exports = __webpack_public_path__ + "static/media/reward-navigation.495342f2.svg";